import { createSelector } from 'reselect';
import { GlobalState } from '../rootReducer';

import { REHYDRATE } from 'redux-persist/constants';

/* Action Types */
export const SET_HEADER_DROPDOWN_VISIBLE = 'SET_HEADER_DROPDOWN_VISIBLE';

/* reducer */
const DEFAULT_STATE = {
    headerDropdownVisible: false,
};

export type State = typeof DEFAULT_STATE;

export default function reducer(state: State = DEFAULT_STATE, action: any = {}) {
    switch (action.type) {
        case REHYDRATE:
            if (
                Object.prototype.hasOwnProperty.call(action.payload, 'persist') &&
                Object.prototype.hasOwnProperty.call(action.payload.persist, 'headerSearchDropdown')
            ) {
                const incoming = action.payload.persist.headerSearchDropdown;
                return { ...state, ...incoming };
            }

            return state;
        case SET_HEADER_DROPDOWN_VISIBLE:
            return {
                ...state,
                headerDropdownVisible: action.payload,
            };
        default:
            return state;
    }
}

/* SELECTORS */
const stateSelector = (state: GlobalState) => state.persist.headerSearchDropdown;

export const isHeaderDropdownVisible = createSelector(stateSelector, (state) => state.headerDropdownVisible);

/* ACTION CREATORS */
export const setHeaderDropdownVisible = (show: boolean = true) => ({
    payload: show,
    type: SET_HEADER_DROPDOWN_VISIBLE,
});
